import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Sarah M., 58',
  image: 'https://cdn.magicpatterns.com/uploads/hjfTuzyUSJKV92gGZC1jP5/hf_20260627_115747_7883f636-739f-4136-a7a2-66a2800f9784.png',
  text: "I thought my gardening days were over. Two weeks of using this and I'm back in the dirt. It's gentle but it actually works."
}, {
  id: 2,
  name: 'Elena R., 62',
  image: 'https://cdn.magicpatterns.com/uploads/ws3Hvet54kVmrZgbaq5qh6/hf_20260627_115654_6e6efb13-f6ed-4cdc-98ef-23fded0b690f.png',
  text: 'The morning stiffness was ruining my life. I use this for 10 minutes while watching TV at night, and I wake up feeling human again.'
}, {
  id: 3,
  name: 'Margaret T., 55',
  image: 'https://cdn.magicpatterns.com/uploads/wS28Qqi81pACFvAKJWBb4Y/hf_20260627_115552_daf3b2e1-1580-4afb-a5e8-c0b82607b85b_(1).png',
  text: "Finally something that isn't a heavy massage gun! It's so light I can easily hold it, and the warmth is incredibly soothing on my neck."
}];
export function Sidebar() {
  return <aside className="w-full lg:w-80 flex-shrink-0 space-y-8" data-id="element-182">
      <div className="bg-brand-rose-light/30 p-6 rounded-xl border border-brand-rose-light" data-id="element-183">
        <h3 className="font-serif text-lg font-bold text-gray-900 mb-4" data-id="element-184">
          What Women Are Saying
        </h3>
        <div className="space-y-6" data-id="element-185">
          {testimonials.map(t => <div key={t.id} className="space-y-3" data-id="element-186">
              <div className="flex items-center gap-3" data-id="element-187">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-188" />
                <div data-id="element-189">
                  <p className="font-medium text-sm text-gray-900" data-id="element-190">{t.name}</p>
                  <div className="flex text-brand-rose" data-id="element-191">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-192" />)}
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-700 italic leading-relaxed" data-id="element-193">
                "{t.text}"
              </p>
              <div className="h-px bg-gray-200 w-full last:hidden" data-id="element-194"></div>
            </div>)}
        </div>
      </div>
    </aside>;
}